import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMyOrders } from "../../../../api/orderService";

export default function LegalEntityOrdersPage() {
    const [orders, setOrders] = useState([]);
    const [error, setError] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        getMyOrders()
            .then(setOrders)
            .catch(() => setError("Failed to load orders"));
    }, []);

    if (error) return <p className="text-red-500">{error}</p>;

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">My Orders</h2>

            {orders.length === 0 ? (
                <p>No orders found</p>
            ) : (
                orders.map((o) => (
                    <div key={o.id} className="border p-3 mb-2 rounded">
                        <p><b>Order:</b> {o.orderNumber}</p>
                        <p><b>Amount:</b> {o.totalAmount} {o.currency}</p>
                        <p><b>Status:</b> {o.paymentStatus}</p>

                        <button
                            className="text-blue-600"
                            onClick={() =>
                                navigate(`/legal/orders/${o.id}`)
                            }
                        >
                            Details
                        </button>
                    </div>
                ))
            )}
        </div>
    );
}